import { render, staticRenderFns } from "./CSlideControlNext.vue?vue&type=template&id=54e18a9a"
import script from "./CSlideControlNext.vue?vue&type=script&lang=js"
export * from "./CSlideControlNext.vue?vue&type=script&lang=js"
import style0 from "./CSlideControlNext.vue?vue&type=style&index=0&id=54e18a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
